import { apiClient } from './client';
import type { AdPlatform, DictQuery, PageData } from './types';

export interface CreateAdPlatformReq {
  platformCode: string;
  platformName: string;
  status?: 0 | 1;
  sort?: number;
  remark?: string;
}

export async function listAdPlatforms(params: DictQuery = {}): Promise<PageData<AdPlatform>> {
  const res = await apiClient.get<PageData<AdPlatform>>('/ads-admin/ad-platforms', { params });
  return res.data;
}

export async function createAdPlatform(req: CreateAdPlatformReq): Promise<AdPlatform> {
  const res = await apiClient.post<AdPlatform>('/ads-admin/ad-platforms', req);
  return res.data;
}

export async function updateAdPlatform(
  platformId: number,
  req: CreateAdPlatformReq,
): Promise<AdPlatform> {
  const res = await apiClient.put<AdPlatform>(`/ads-admin/ad-platforms/${platformId}`, req);
  return res.data;
}

export async function setAdPlatformStatus(platformId: number, status: 0 | 1): Promise<void> {
  await apiClient.put(`/ads-admin/ad-platforms/${platformId}/status`, { status });
}
